//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonAction from '@/shared/components/ButtonAction.vue';

export default {
  name: 'SupportRow',
  components: {
    ButtonAction,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    triggerChat() {
      // eslint-disable-next-line no-undef
      openDriftChat();
    },
  },
};
